export class BrowserDetectUtil {
	
	public static isIe(): boolean {

		var isIE = false;
		if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
			isIE = true;
		}


		return isIE;

	}

	public static isSafari(): boolean {

		if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) return true;

		return false;

	}

	public static isMac(): boolean {

		var isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;

		return isMacLike;

	}

	public static isFirefox() {
		return navigator.userAgent.indexOf('Firefox') !== -1;
	}
}